import { onCleanup, onMount } from "solid-js";
import { AuthProvider, useAuth } from "~/lib/auth";
import { subscribeToAll } from "~/lib/realtime";
import { applyUpdateOnNavigation } from "~/lib/sw-update";

import { QueryClient, QueryClientProvider, keepPreviousData } from "@tanstack/solid-query";
import { useQueryClient } from "@tanstack/solid-query";
import { RouterProvider } from "@tanstack/solid-router";

import { getRouter } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      placeholderData: keepPreviousData,
    },
  },
});

function RealtimeProvider(props: { children: any }) {
  const qc = useQueryClient();
  onMount(() => {
    const unsub = subscribeToAll(qc);
    onCleanup(unsub);
  });
  return <>{props.children}</>;
}

function InnerApp() {
  const { state } = useAuth();
  const router = getRouter();

  // A deployed update waits for a safe moment before swapping in (lib/sw-update).
  // A route change is one such moment: if a new build is pending, the next
  // navigation hard-loads its destination from the fresh worker.
  const unsubscribe = router.subscribe("onBeforeNavigate", (e) => {
    if (e.pathChanged) applyUpdateOnNavigation(e.toLocation.href);
  });
  onCleanup(unsubscribe);

  return (
    <RealtimeProvider>
      <RouterProvider router={router} context={{ auth: state }} />
    </RealtimeProvider>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <InnerApp />
      </AuthProvider>
    </QueryClientProvider>
  );
}
